<template>
  <div class="header">
    <div class="item">
      <!-- 配送单号： -->
      <p>
        <span>{{ $t("message.deliveryNoteNumber") }}:</span>
        {{ detail.porder_sn }}
      </p>
      <!-- 配送单类别： -->
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    detail() {
      return this.$parent.previewData;
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.header {
  padding: 24px;
  background-color: #32323c;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  min-width: 1662px;
  .label {
    margin-right: 60px;
  }
  .item {
    p {
      margin-bottom: 20px;
      span {
        display: inline-block;
        width: 80px;
      }
      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
  .border {
    margin: 0 80px;
    background-color: #545467;
    width: 1px;
  }
}
</style>